var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {callApi} from "./api";
export function leaveReview(user_id, message, rating, call_id) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/review/`, {
      method: "POST",
      body: {
        user_id,
        message,
        rating,
        call_id
      }
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function leaveReviewResponse(review_id, message) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/review/response`, {
      method: "POST",
      body: {
        review_id,
        message
      }
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function moderateReview(review_id) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/review/moderate`, {
      method: "POST",
      body: {review_id}
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function fetchReviewsList(offset, limit, sort, corder) {
  return __async(this, null, function* () {
    var _a;
    const order = !!corder ? corder === "ascend" ? "ASC" : "DESC" : "";
    const callsListResponse = yield callApi(`/review/`, {query: {offset, limit, sort, order}});
    return (_a = callsListResponse.payload) == null ? void 0 : _a.data;
  });
}
export function fetchPastCalls(userId) {
  return __async(this, null, function* () {
    var _a, _b;
    const callsListResponse = yield callApi(`/call/past`, {query: {userId}});
    return ((_b = (_a = callsListResponse.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.list) || [];
  });
}
